import { Dropdown, DropdownButton } from "react-bootstrap";
import React from "react";
import { SECTIONS } from "../PlayerSection/PlayerSection";
import CustomDropdownButton from "../GameElements/CustomDropdownButton";

export default function TopCardDropdown({
    playerId,
    opponentIds,
    opponentsData,
    deck,
    topCardHiddenTo,
    setShowTopDeckManager,
    setShowDeckSearch,
    setIsTextInputFocused,
    sendToHistory,
    setTopCardHiddenTo,
    toSection,
    shuffleDeck,
    giveCardAtIndexTo,
    setShowDrawXModal
}) {
    function hideTopCard(val) {
        let newTopCardHiddenTo = { ...topCardHiddenTo };
        const keepVisibility = newTopCardHiddenTo["KEEP"];

        if (val === "yes") {
            [...opponentIds, playerId].forEach((id) => {
                newTopCardHiddenTo[id] = true;
            });
            sendToHistory("hid their deck top card");
        } else if (val === "opponent-only") {
            newTopCardHiddenTo = {};
            opponentIds.forEach((id) => {
                newTopCardHiddenTo[id] = true;
            });
            sendToHistory("hid their deck top card from other players");
        } else if (val === "no") {
            newTopCardHiddenTo = {};
            sendToHistory("revealed from the top of their deck", deck.at(-1));
        } else {
            if (newTopCardHiddenTo[val]) {
                delete newTopCardHiddenTo[val];
                sendToHistory("revealed top card to one player", deck.at(-1));
            } else {
                newTopCardHiddenTo[val] = true;
                sendToHistory("hid top card from one player", deck.at(-1));
            }
        }

        newTopCardHiddenTo["KEEP"] = keepVisibility;
        setTopCardHiddenTo(newTopCardHiddenTo);
    }

    function toggleKeepTopCardHidden() {
        const updated = { ...topCardHiddenTo };
        if (updated["KEEP"] === true) {
            delete updated["KEEP"];
            sendToHistory("removed their deck top card visibility from permanent");
        } else {
            updated["KEEP"] = true;
            sendToHistory("set their deck top card visibility to permanent");
        }
        setTopCardHiddenTo(updated);
    }

    return (
        <>
            <CustomDropdownButton drop="start" title="Top card visibility" className="submenu w-100">
                <Dropdown.Item onClick={() => hideTopCard("no")}>All</Dropdown.Item>
                <Dropdown.Item onClick={() => hideTopCard("yes")}>No one</Dropdown.Item>
                <Dropdown.Item onClick={() => hideTopCard("opponent-only")}>Only you</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item className={topCardHiddenTo["KEEP"] ? "selected" : ""} onClick={toggleKeepTopCardHidden}>
                    Keep on deck change
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item className={!topCardHiddenTo[playerId] ? "selected" : ""} onClick={() => hideTopCard(playerId)}>
                    You
                </Dropdown.Item>
                {opponentIds.map((o) => (
                    opponentsData[o] && (
                        <Dropdown.Item
                            className={!topCardHiddenTo[o] ? "selected" : ""}
                            key={o}
                            onClick={() => hideTopCard(o)}
                        >
                            {opponentsData[o].profileData.name}
                        </Dropdown.Item>
                    )
                ))}
            </CustomDropdownButton>
            <Dropdown.Divider />
            <CustomDropdownButton drop="start" title="Give top hidden" className="submenu w-100">
                {opponentIds.map((o) => (
                    opponentsData[o] && (
                        <Dropdown.Item
                            className={!topCardHiddenTo[o] ? "selected" : ""}
                            key={o}
                            onClick={() => giveCardAtIndexTo(-1, o, SECTIONS.EXILE_HIDDEN)}
                        >
                            {opponentsData[o].profileData.name}
                        </Dropdown.Item>
                    )
                ))}
            </CustomDropdownButton>
            <Dropdown.Item onClick={() => toSection(0, SECTIONS.DISCARD)}>Discard top</Dropdown.Item>
            <Dropdown.Item onClick={() => { setShowTopDeckManager(true); setShowDeckSearch(false); }}>
                Manage top cards
            </Dropdown.Item>
            <Dropdown.Item onClick={() => { setShowDeckSearch(true); setShowTopDeckManager(false); setIsTextInputFocused(true); }}>
                Search
            </Dropdown.Item>
            <Dropdown.Item onClick={shuffleDeck}>Shuffle</Dropdown.Item>
            <Dropdown.Item onClick={() => setShowDrawXModal(true)}>Draw X</Dropdown.Item>
        </>
    );
}